import omit from 'lodash/omit';
import mergeWith from 'lodash/mergeWith';
import { initialState } from './selectors';
import { ENTITIES_DELETE, ENTITIES_RECEIVE } from './actions';

export default (state = initialState, { type, payload }) => {
  if (type === ENTITIES_RECEIVE) {
    return mergeWith({}, state, payload, (objValue, srcValue) => {
      if (Array.isArray(srcValue)) {
        return srcValue;
      }

      return undefined;
    });
  }
  if (type === ENTITIES_DELETE) {
    const needle = payload.id;
    const resource = payload.schema.key;
    const list = state[resource];
    const doneList = needle ? omit(list, needle) : {};

    return {
      ...state,
      [resource]: doneList,
    };
  }
  return state;
};
